'use client'
import { Box, Text, Flex, Icon, Button } from '@chakra-ui/react'
import { BottomNav } from '@/components/ui/bottom-nav'
import { FaRegEdit } from 'react-icons/fa'
import NextLink from 'next/link'
import SubscriptionsFeed from './SubscriptionsFeed'
import GuestView from './guest/GuestView'
import { useState } from 'react'
import { useUser } from '@/src/store/user-store'

export default function SubscriptionsPage() {
  const { user, _hasHydrated } = useUser()
  const [noSubscriptions, setNoSubscriptions] = useState(false)

  if (_hasHydrated && !user) {
    return (
      <>
        <GuestView />
      </>
    )
  }

  return (
    <>
      <Flex justify={'flex-end'} p={0} minH="100vh">
        <Box className="hi" w="100%" zIndex={2} pb={[20, 10]}>
          <Box pb={10} px={[4, 4, 4]} mt={4}>
            {!noSubscriptions ? (
              <Box>
                <Flex justify="space-between" align="center" mb={4}>
                  <Text fontWeight="bold" fontSize="lg">
                    All subscriptions
                  </Text>
                  <Button
                    as={NextLink}
                    minW={'auto'}
                    leftIcon={<Icon as={FaRegEdit} h={[4]} w={[4]} />}
                    variant="ghost"
                    px={0}
                    _hover={{ bg: 'transparent' }}
                    _active={{ bg: 'transparent' }}
                    fontWeight="400"
                    size="sm"
                    href="/subscriptions/view"
                  >
                    Manage Subscriptions
                  </Button>
                </Flex>
              </Box>
            ) : null}
            <SubscriptionsFeed setNoSubscriptions={setNoSubscriptions} />
          </Box>
        </Box>
        <BottomNav />
      </Flex>
    </>
  )
}
